// hooks/useShipping.js
import { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { conf } from '../../../confg';
import { shipping_price_setter } from '../../../actions/cartActions';

/**
 * Custom hook for managing shipping methods and calculations
 */
export const useShipping = () => {
  const dispatch = useDispatch();
  const [shippingMethods, setShippingMethods] = useState([]);
  const [shippingTimes, setShippingTimes] = useState([]);
  const [shippingPrice, setShippingPrice] = useState(null);
  const [loading, setLoading] = useState(false);
  const [shippingInsurance, setShippingInsurance] = useState({
    with_insurance: null,
    without_insurance: null,
  });

  const loadShippingMethods = useCallback(async () => {
    try {
      const response = await axios({
        url: conf.server_url + 'shipping_method',
        method: 'GET',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setShippingMethods(response.data);
    } catch (error) {
      console.error('Error loading shipping methods:', error);
    }
  }, []);

  const loadShippingTimes = useCallback(async () => {
    try {
      const response = await axios({
        url: conf.server_url + 'shipping/dates',
        method: 'GET',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setShippingTimes(response.data);
    } catch (error) {
      console.error('Error loading shipping times:', error);
    }
  }, []);

  const calculateShippingPrice = useCallback(
    async (shippingMethodId, addressId, totalPrice) => {
      if (!shippingMethodId || !addressId) return;

      setLoading(true);
      const form = new FormData();
      form.append('shipping_method_id', shippingMethodId);
      form.append('address_id', addressId);
      form.append('total', totalPrice);

      try {
        const response = await axios({
          url: conf.server_url + 'shipping/calculate_price',
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
          data: form,
        });

        const withInsurance = parseFloat(response.data.with_insurance / 10).toFixed(0);
        const withoutInsurance = response.data.price === 0 ? 0 : parseFloat(response.data.price / 10).toFixed(0);

        const finalPrice = response.data.with_insurance ? withInsurance : parseFloat(response.data.price / 10);

        setShippingPrice(finalPrice);
        setShippingInsurance({
          with_insurance: withInsurance,
          without_insurance: withoutInsurance,
        });

        dispatch(shipping_price_setter(finalPrice));
      } catch (error) {
        console.error('Error calculating shipping price:', error);
      } finally {
        setLoading(false);
      }
    },
    [dispatch],
  );

  useEffect(() => {
    loadShippingMethods();
    loadShippingTimes();
  }, [loadShippingMethods, loadShippingTimes]);

  return {
    shippingMethods,
    shippingTimes,
    shippingPrice,
    shippingInsurance,
    loading,
    calculateShippingPrice,
    loadShippingMethods,
    loadShippingTimes,
  };
};
